import {
  Anchor,
  Text,
  Group,
  TextProps,
  StyleProp,
  MantineSpacing,
} from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"

export const ToggleCollapse = ({
  seeMoreLabel,
  seeLessLabel,
  open,
  toggle,
  iconSize = 16,
  textProps,
  color = "var(--mantine-color-gray-5)",
  pb = "xs",
}: {
  seeMoreLabel?: string | React.ReactNode
  seeLessLabel?: string | React.ReactNode
  open: boolean
  toggle: () => void
  iconSize?: number
  color?: string
  textProps?: TextProps
  pb?: StyleProp<MantineSpacing> | false
}) => {
  const showLabels = seeMoreLabel && seeLessLabel

  const seeMoreLabelComponent =
    typeof seeMoreLabel === "string" ? (
      <Text {...textProps}>{seeMoreLabel}</Text>
    ) : (
      seeMoreLabel
    )

  const seeLessLabelComponent =
    typeof seeLessLabel === "string" ? (
      <Text {...textProps}>{seeLessLabel}</Text>
    ) : (
      seeLessLabel
    )

  return (
    <Group wrap="nowrap" justify="space-between" pb={pb ? pb : undefined}>
      <Anchor fw="bold" onClick={toggle}>
        <Group gap={4} align="center">
          {showLabels && (open ? seeLessLabelComponent : seeMoreLabelComponent)}
          <IconChevronDown
            size={iconSize}
            color={color}
            style={{
              transform: open ? "rotate(0deg)" : "rotate(-90deg)",
              transition: "transform 0.2s",
            }}
          />
        </Group>
      </Anchor>
    </Group>
  )
}
